import { createI18n } from 'vue-i18n'
import { getQueryVariable } from '@/utils/const'
import message from './i18n'

// sc简体，tc繁体，en英语
const hash: Record<string, string> = {
  sc: 'sc',
  tc: 'tc',
  en: 'en'
}
const lang: any = getQueryVariable('lang')
window.localStorage.setItem('lang', lang)
const locale = lang ? hash[lang as string] : 'sc'

const i18n = createI18n({
  legacy: false,
  locale,
  messages: message
})

export default i18n
